module.exports = __webpack_public_path__ + "static/media/CircularPro-BookItalic.b8bd9564.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-BookItalic.ttf
// module id = 116
// module chunks = 0